<template>
  <div class="business">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="3"></menuBox>
      <div class="banner-text">
        <div class="title">Layanan kami</div>
        <div class="text">
          PT LAYAR CERITA IMAJINASI menyediakan layanan perencanaan periklanan dan penempatan media yang komprehensif untuk membantu perusahaan meningkatkan pengaruh merek mereka.
        </div>
      </div>
    </div>
    <div class="mission-box">

      <div class="content">
        <div class="title">
          Visi kami
        </div>
        <div class="text">
          PT LAYAR CERITA IMAJINASI berkomitmen untuk menjadi pemimpin di bidang periklanan dan perencanaan media yang inovatif, membantu pelanggan mencapai keunggulan merek dan mendorong perkembangan industri dengan terus meningkatkan kreativitas dan kualitas layanan.
        </div>
      </div>
      <img src="../assets/mession-3.png" alt="" />
    </div>
    <div class="build-box">
      <div class="left">
        <div class="title">
          Ulasan Pelanggan
        </div>
        <div class="text">
          Sebagai pelanggan kami sangat puas dengan pelayanan PT LAYAR CERITA IMAJINASI. Perencanaan periklanan yang kreatif dan solusi penempatan media yang tepat yang mereka berikan membantu kami meningkatkan pengaruh merek kami secara signifikan. 
        </div>
        <img src="../assets/mession-user.png" alt="">
      </div>
      <img src="../assets/mession-4.png" class="middle" alt="">
      <div class="right">
        <div class="text">
          Timnya profesional dan efisien, benar-benar memahami kebutuhan kami, dan merupakan mitra terpercaya kami.
        </div>
        <div class="title">
          100%
        </div>
        <div class="l-title">
          tim profesional
        </div>
      </div>
    </div>
    <div class="wealth-box">
      <div class="title">
        Evaluasi diri tim
      </div>
      <img src="../assets/star.png" alt="">
      <div class="text">
        Sebagai pemimpin tim, saya sangat bangga dengan tim kami. Kami memiliki tim yang kreatif, profesional, dan efisien, dan setiap anggota berdedikasi untuk menyediakan solusi perencanaan periklanan dan penempatan media terbaik kepada pelanggan. Kami terus-menerus mengejar inovasi dan berusaha melampaui harapan pelanggan. Profesionalisme dan keunggulan inilah yang membuat kami menonjol di industri ini.
      </div>
      <div class="user">
        <img src="../assets/user-1.png" alt="">
        <p>DONALD SIMPSON <br> <span>Team Leader</span></p>
      </div>
      <div class="number">
        <span>+35% </span>
        Increase in sales
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";
  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {};
    },
    mounted() { },
    methods: {
      aboutUs() {
        this.$router.push({ path: "aboutUs" });
      },
      submit() {
        alert("Success");
      },
    },
  };
</script>
<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-2.png);
    height: 500px;
    background-size: 100% 100%;

    .banner-text {
      margin: 0 360px;
      padding-top: 100px;
      text-align: center;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 64px;
        color: #333333;
      }

      .text {
        font-size: 26px;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        margin-top: 20px;
      }
    }
  }

  .mission-box {
    padding: 150px 360px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .content {
      width: 650px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 52px;
        color: #252B42;
        margin: 17px 50px;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: #737373;
        margin: 0px 50px;
      }
    }

    img {
      width: 534px;
      height: 359px;
    }
  }

  .build-box {
    padding: 110px 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FCDB67;

    .left {
      width: 360px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 52px;
        color: #252B42;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        margin-top: 20px;
      }

      img {
        width: 93px;
        margin-top: 20px;
      }
    }

    .middle {
      width: 430px;
      margin: 0 50px;
    }

    .right {
      width: 360px;

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
      }

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 52px;
        color: #252B42;
        margin-top: 70px;
      }

      .l-title {
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 26px;
        color: rgba(37, 43, 66, 0.6);
        margin-top: 14px;
      }
    }
  }

  .wealth-box {
    padding: 150px 360px;
    background: #FEFBF6;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 52px;
      color: #252B42;
    }

    img {
      height: 47px;
      margin-top: 30px;
    }

    .text {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      margin: 0 100px;
      margin-top: 40px;
    }

    .user {
      margin-top: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 80px;
        height: 80px;
        float: left;
        margin-top: 0;
        margin-right: 30px;
      }

      p {
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        span {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 20px;
          color: #333333;
        }
      }
    }

    .number {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 28px;
      color: #333333;
      margin-top: 100px;

      span {
        font-family: DIN, DIN;
        font-weight: bold;
        font-size: 42px;
        color: #333333;
      }
    }
  }
</style>